package views.componentes

import androidx.compose.runtime.*
import ffEspHorizontalMM
import ffValidar
import fontSmall
import kotlinx.browser.document
import kotlinx.dom.clear
import ffMsgAviso
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.attributes.AutoComplete.Companion.off
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.*
import utils.*
import utils.ff.Companion.giClick
//import utils.ff.Companion.giClick
import utils.ff.Companion.giId
import utils.ff.Companion.gsBrowser
import utils.ff.Companion.gsDesenvolvedor
import utils.ff.Companion.gsUrlLogon

//import utils.ff.Companion.gsKey
import utils.ff.Companion.println0

var gsKey = ""
var gsTextAnt = ""
var keyCount = 0

//private var textH: HTMLInputElement? = null

class input1(

    //var id: String,
    //var status: String, //inv ou //dis //focus
    var text: String
    //var gsKey: String = ""
)

private fun geraId(_tela: String, _id: String, _tipo: String): String {
    var id = _id
    if (id.equals("")) {
        giId += 1;
        id = _tela + "_$_tipo${giId.ffZeroLeft(6)}"
    }
    return id
}

fun gsInput(
    _tela: String,
    _id: String = "",
    _text: String = "",
    _textAnt: String = "",
    _tipo: String = "",
    _enabled: Boolean = true,
    _focus: String = "",
    _textItens: String = ""
): String {
    val id = geraId(_tela, _id, "tx")
//    var bEnabled = "true"
//    if (_enabled.equals("false"))
//        bEnabled = "false"
    return "|status=|enabled=$_enabled|focus=$_focus|text=$_text|textAnt=$_textAnt|id=$id|key=|tipo=$_tipo" +
            "|textItens=$_textItens|textselect=|clickObj=|json=|atualizar=false|clickTipo=|carregado=nao|span=|tela=$_tela|count=0|"
}

@Composable
fun ffInput44_ant(
    //aparentemente funciona em coletores mais antigo
    _text: String,
    _valor: MutableState<String>,
    _tipoCampo: String,
    _max: Int,
    _width: Int,
    _esp: Boolean = true,
    _onFocusIn: (Boolean) -> Unit,
    _onFocusOut: (Boolean) -> Unit,
    _onKeyUpEnter: (Boolean) -> Unit,
    //_onclick: (Boolean) -> Boolean
): Unit {

    var width = _width
    if (width == 0)
        width = 100

    if (_valor.tipo().equals(""))
        _valor.tipo(_tipoCampo)


    //_valor.carregado("nao")
    //Div({ classes("input-group-append") }) {

    return Div({
        id("div${_valor.id()}")
        style { width(width.percent); fontSize(fontSmall); }
    }) {
        if (!_text.equals("")) {
            //println0("vai99 por nome no span = span${_valor.id()}, text = ${_valor.text()}")
            Span({ id("${_valor.tela()} span${_valor.id()}") }) {
                if (_valor.span().equals(""))
                    Text("$_text".trim())
                else
                    Text(_valor.span().trim())
            }

            Br()
        }
        Div({ classes("form-group", "input-group-append"); style { fontSize(fontSmall) } }) {
            Input(

                type = if (_tipoCampo.ffSubstring1(1).equals("D") && _valor.enabled() && _valor.text().length < 14) {
                    InputType.Text
                } else if (_tipoCampo.ffSubstring1(1).equals("N")) {
                    InputType.Number
                } else if (_tipoCampo.equals("NS") && _valor.enabled()) {
                    InputType.Text
                } else if (_tipoCampo.equals("PS") && _valor.enabled()) {
                    InputType.Password
                } else {
                    InputType.Text
                },


                //type = InputType.Text,
                //value = _valor.text(),

                attrs = {
                    //_valor.inputType(_tipoCampo)

                    //step(1)
                    if (!_valor.id().equals("")) {
                        id(_valor.id())
                    }

                    if (!_valor.text().equals("") && _valor.carregado().equals("")) {
                        //println0("atribui88 defaultValue")
                        defaultValue(_valor.text())
                    }

                    classes("form-control")
                    if (_tipoCampo.equals("NS")) {
                        if (_valor.text().equals(""))
                            placeholder(_text)
                        else if (!_valor.enabled())
                            placeholder(_valor.text())
                    }

                    if (_tipoCampo.equals("N"))
                        style { (textAlign("right")); fontSize(fontSmall) }
                    else
                        style { fontSize(fontSmall) }


                    onFocusIn { _ ->
                        _onFocusIn.invoke(true)
                    }

                    onFocusOut {
                        _onFocusOut.invoke(true)
                    }

                    onKeyUp {
                        if ("Enter".contains(it.getNormalizedKey()))
                            _onKeyUpEnter.invoke(true)
                    }

                    onChange {
                        //println0("zuza96 vai aqui ${_valor.text()}")
                        _valor.text(_valor.text_getPROBLEMA())
                        if (_tipoCampo.equals("NS")) {
                            _valor.text(
                                ffValidar(
                                    _valor.text(),
                                    _valor.tipo(),
                                    _max
                                )
                            );
                        } else {
                            value(_valor.text())
                        }
                        //println0("zuza98 vai aqui ${_valor.text()}")
                        //println0("zuza97 vai aqui ${_valor.text()} ${_valor.value}")
                        if (_tipoCampo.equals("NS")) {
                            //println0("vai setar o value 44")
                            _valor.setVal(_valor.text())
                            //_valor.setVal(_valor.text())
                        } else
                            value(_valor.text())

                        //_valor.setFocus("");
                        if (_valor.key().equals("Enter") ||
                            (gsBrowser.contains("mobile") && !_valor.text().equals(""))
                        ) {
                            _valor.key("Enter");
                            gsKey = "Enter" //necessário para o celular
                        }

                    }

                    onFocus {
                        //msgAviso("")
                        //_valor.text("")
                        _valor.key("")
                        _valor.setFocus("entrou")
                    }

//                    onFocusOut { não liberar isso
//
//                        if (_valor.key().equals("Enter") || (gsBrowser.contains("mobile") && !_valor.text().equals(""))) {
//                            _valor.key("Enter"); gsKey = "Enter"; //necessário para o celular
//                        }
//                    }

                    onKeyDown {
                        //27891962051349
                        //println0(it.getNormalizedKey() + " text=" + _valor.text() + " id=" + _valor.id())
                        //_valor.text(_valor.text_get())

                        //_valor.setVal(_valor.text())
                        //value(_valor.text())

                        //_valor.text_set()
                        //value()
                        //msgAviso(it.getNormalizedKey() + _valor.id())
                        //msgAviso(it.getNormalizedKey() + " " + _valor.id() + " " + _valor.atualizar())

                        if ("Enter,Backspace,Delete".contains(it.getNormalizedKey())) {
                            gsKey = it.getNormalizedKey();
                            _valor.key(it.getNormalizedKey());
                            if (it.getNormalizedKey().equals("Enter")) {
                                _valor.atualizar()
                            }
                            if ("Backspace,Delete".contains(it.getNormalizedKey()) && _valor.text().length == 1) {
                                _valor.text("")
                            }

                            //println0("onKeyDown"); //; println0(it.getNormalizedKey() + " " + _valor.text())
                        } else if (!_valor.key().equals("")) {
                            _valor.key("")
                            gsKey = ""
                        }
                    }

                    if ((!_valor.text().equals("") && _valor.carregado().equals("nao")) || !_valor.enabled()) {
                        _valor.text_set()
                        if (!_valor.carregado().equals("nao") && _valor.enabled()) {
                            //println0("_valor.enabled=" + _valor.enabled() + " carregado=" + _valor.carregado())
                            _valor.carregado("sim")
                        }
                    }

//                    value(_valor.text())

                    if (_valor.carregado().equals("nao") && !_valor.text().equals("")) {
                        //println0("vai colocar o valor carregado ${_valor.text()}")
                        //if (_valor.carregado().equals("nao") && !_valor.text().equals(""))
                        value(_valor.text())
                        _valor.carregado("sim")
                    }

                    //_valor.text_set()

                    if (!_valor.enabled())
                        disabled()

                    if (_valor.setFocus().equals("true")) {

                        try {
                            if (!_valor.id().equals("")) {
                                _valor.setFocus("");
                                (document.getElementById(_valor.id()) as HTMLInputElement).focus()
                            }
                        } catch (e: Exception) {
                            println0("Falha ao fazer setFocus ${_valor.id()} erro = ${e.message}")
                        }

                        println0(
                            "zuza779_1 tipoCampo = " + _valor.tipo()
                                .ffSubstring1(1) + " enabled = " + _valor.enabled() + " focus " + _valor.setFocus()
                        )
                    }
                }

            )
            if (_esp)
                ffEspHorizontalMM(3)
        }
    }
}

@Composable
fun ffInput1(  //aparentemente não funciona em coletores mais antigos, mas funciona nos androids mais novos
    _text: String,
    _valor: MutableState<String>,
    _tipoCampo: String,
    _max: Int,
    _width: Int,
    _esp: Boolean = true
    //_onclick: (Boolean) -> Boolean
): Unit {
    ffInput1(_text, _valor, _tipoCampo, _max, _width, {}, {}, _esp)
}

@Composable
fun ffInput1(  //aparentemente não funciona em coletores mais antigos, mas funciona nos androids mais novos
    _text: String,
    _valor: MutableState<String>,
    _tipoCampo: String,
    _max: Int,
    _width: Int,
    _onFocusOut: (Boolean) -> Unit,
    _onFocusIn: (Boolean) -> Unit,
    _esp: Boolean = true
    //_onclick: (Boolean) -> Boolean
): Unit {

    var width = _width
    if (width == 0)
        width = 100

    if (_valor.tipo().equals(""))
        _valor.tipo(_tipoCampo)


    return Div({ id("div${_valor.id()}")
        style { width(width.percent); fontSize(fontSmall) }
    }) {
        if (!_text.equals("")) {
            //println0("vai99 por nome no span = span${_valor.id()}, text = ${_valor.text()}")
            Span({ id("${_valor.tela()} span${_valor.id()}") }) {
                if (_valor.span().equals(""))
                    Text("$_text".trim())
                else
                    Text(_valor.span().trim())
            }

            Br()
        }
        Div({ classes("form-group", "input-group-append"); style { fontSize(fontSmall) } }) {

            Input(
                type = when {
                    _tipoCampo.ffSubstring1(1) == "D" && _valor.enabled() && _valor.text().length < 14 -> {
                        if (gsBrowser.contains("mobile")) InputType.Text else InputType.Text
                    }
                    _tipoCampo == "NS" && _valor.enabled() -> InputType.Text
                    _tipoCampo.ffSubstring1(1) == "N" -> InputType.Number
                    _tipoCampo == "PS" && _valor.enabled() -> InputType.Password
                    else -> InputType.Text
                },
                attrs = {
                    autoComplete(off)
                    if ("D".contains(_tipoCampo.ffSubstring1(1)))
                        inputMode("numeric")
                    else
                        inputMode("text")

                    if (_valor.id().isNotEmpty()) id(_valor.id())
                    if (_valor.id().isNotEmpty() && _valor.carregado() == "nao" && _valor.text().isEmpty()) {
                        if (_tipoCampo == "NS") placeholder(_text)
                    }
                    if (_valor.text().isNotEmpty() && _valor.carregado().isEmpty()) {
                        defaultValue(_valor.text())
                    }
                    classes("form-control")
                    if (_tipoCampo == "NS" && !_valor.enabled()) {
                        placeholder(_valor.text())
                    }
                    style {
                        if (_tipoCampo == "N") {
                            textAlign("right")
                            fontSize(fontSmall)
                        } else {
                            fontSize(fontSmall)
                        }
                    }
                    onChange {
                        _valor.text(
                            ffValidar(
                                _valor.text(),
                                _valor.tipo(),
                                _max
                            )
                        )
                        _valor.setVal(_valor.text())
                        _valor.setFocus("")
//                        if (_valor.key() == "Enter" || (gsBrowser.contains("mobile") && _valor.text().isNotEmpty())) {
//                            _valor.key("Enter")
//                            gsKey = "Enter"
//                        }
                    }
                    onFocus {
                        _valor.key("")
                        _valor.setFocus("entrou")
                        //(document.getElementById(_valor.id()) as HTMLInputElement).focus() //implementado dia 03/01/2025
                    }
                    onFocusOut { _onFocusOut.invoke(true) }
                    onFocusIn { _onFocusIn.invoke(true) }
                    onDoubleClick { _valor.select() }

                    onKeyDown {

                        gsKey = it.getNormalizedKey()
                        if ("Enter,Backspace,Delete".contains(gsKey)) {
                            _valor.key(gsKey)
                            if (gsKey == "Enter") {
                                _valor.atualizar()
                            }
                        }
                    }

                    /*
                    onKeyUp {
                        gsKey = it.getNormalizedKey()
                        if ("Enter,Backspace,Delete".contains(gsKey)) {
                            _valor.key(gsKey)
                            if (gsKey == "Enter") {
                                _valor.atualizar()
                            }
                        }
                    }

                     */
                    value(_valor.text())
                    onInput {
                        if ((_valor.carregado() == "nao" || _valor.carregado() == "n") && _valor.enabled()) {
                            _valor.carregado("sim")
                        }
                        _valor.text(it.value.toString(), _onInput = true)
                    }
                    if (!_valor.enabled()) disabled()
                    if (_valor.setFocus() == "true") {
                        try {
                            if (_valor.id().isNotEmpty()) {
                                _valor.setFocus("")
                                (document.getElementById(_valor.id()) as HTMLInputElement).focus()
                            }
                        } catch (e: Exception) {
                            println0("Falha ao fazer setFocus ${_valor.id()} erro = ${e.message}")
                        }
                    }
                }
            )

            if (_esp)
                ffEspHorizontalMM(3)
        }
    }
}

@Composable
fun ffInputN(
    _text: String,
    _valor: MutableState<String>,
    _tipoCampo: String,
    _max: Int,
    _width: Int,
    _esp: Boolean = true
    //_onclick: (Boolean) -> Boolean
): Unit {

    var width = _width
    if (width == 0)
        width = 100

    if (_valor.tipo().equals(""))
        _valor.tipo(_tipoCampo)


    //_valor.carregado("nao")
    //Div({ classes("input-group-append") }) {

    return Div({ id("div${_valor.id()}")
        style { width(width.percent); fontSize(fontSmall); }
    }) {
        if (!_text.equals("")) {
            //println0("vai99 por nome no span = span${_valor.id()}, text = ${_valor.text()}")
            Span({ id("${_valor.tela()} span${_valor.id()}") }) {
                if (_valor.span().equals(""))
                    Text("$_text".trim())
                else
                    Text(_valor.span().trim())
            }

            Br()
        }
        Div({ classes("form-group", "input-group-append"); style { fontSize(fontSmall) } }) {
            NumberInput(

                value = _valor.text().ffVsi(),

                attrs = {
                    //if (_max > 0)
                    //  max(_max.toString())

                    if (!_valor.id().equals("")) {
                        id(_valor.id())
                        if (_tipoCampo.equals("NS"))
                            placeholder(_text)
                    }

                    if (!_valor.text().equals("") && _valor.carregado().equals("")) {
                        //println0("atribui88 defaultValue")
                        defaultValue(_valor.text())
                    }

                    classes("form-control")

                    if (_tipoCampo.equals("NS") && (!_valor.enabled())) {
                        placeholder(_valor.text())
                    }

                    if (_tipoCampo.equals("N"))
                        style { (textAlign("right")); fontSize(fontSmall) }
                    else
                        style { fontSize(fontSmall) }

                    onChange {
                        //println0("zuza96 vai aqui ${_valor.text()}")
                        //_valor.text(_valor.text_get())
                        //msgAviso("entrou no onChange")

                        _valor.setFocus("");
                        if (_valor.key().equals("Enter") ||
                            (gsBrowser.contains("mobile") && !_valor.text().equals(""))
                        ) {
                            _valor.key("Enter");
                            gsKey = "Enter" //necessário para o celular
                        }

                    }

                    onFocus {
                        //msgAviso("")
                        _valor.key("")
                        _valor.setFocus("entrou")
                    }

                    onKeyDown { //esse é o primeiro evento a disparar

                        gsKey = it.getNormalizedKey();
                        if ("Enter,Backspace,Delete".contains(it.getNormalizedKey())) {
                            gsKey = it.getNormalizedKey();
                            _valor.key(it.getNormalizedKey());
                            if (it.getNormalizedKey().equals("Enter")) {
                                _valor.atualizar()
                            }
                            //println0("onKeyDown"); //; println0(it.getNormalizedKey() + " " + _valor.text())
                        }
                    }

                    value(_valor.text())

                    onInput {
                        if ((_valor.carregado().equals("nao") || _valor.carregado().equals("n")) && _valor.enabled()) {
                            _valor.carregado("sim")
                        }
                        _valor.text(it.value.toString(), _onInput = true)
                    }

                    onKeyUp { //evento de quando a tecla é largada
                    }

                    if (!_valor.enabled())
                        disabled()

                    if (_valor.setFocus().equals("true")) {

                        try {
                            if (!_valor.id().equals("")) {
                                _valor.setFocus("");
                                (document.getElementById(_valor.id()) as HTMLInputElement).focus()
                            }
                        } catch (e: Exception) {
                            println0("Falha ao fazer setFocus ${_valor.id()} erro = ${e.message}")
                        }

                        println0(
                            "zuza779_1 tipoCampo = " + _valor.tipo()
                                .ffSubstring1(1) + " enabled = " + _valor.enabled() + " focus " + _valor.setFocus()
                        )
                    }
                }

            )
            if (_esp)
                ffEspHorizontalMM(3)
        }
    }
}

@Composable
fun ffInput1Acao(
    _text: String,
    _valor: MutableState<String>,
    _tipoCampo: String,
    _max: Int,
    _width: Int,
    _esp: Boolean = true,
    _acao: (Boolean) -> Unit
    //_onclick: (Boolean) -> Boolean
): Unit {

    var width = _width
    if (width == 0)
        width = 100

    if (_valor.tipo().equals(""))
        _valor.tipo(_tipoCampo)

    //println("zuza777 tipoCampo = " + _valor.tipo().ffSubstring(1) + " enabled = " + _valor.enabled() + " focus " + _valor.setFocus())

    return Div({ style { width(width.percent); fontSize(fontSmall) } }) {
        Span { Text("$_text".trim()) }
        Br()
        Div({ classes("form-group", "input-group-append"); style { fontSize(fontSmall) } }) {
            Input(
                //type = if (_valor.tipo().substring(1).equals("N")) { InputType.Number } else ( InputType.Text ),
                type = if (_tipoCampo.ffSubstring1(1).equals("N") && _valor.enabled()) {
                    InputType.Number
                } else {
                    InputType.Text
                },
                attrs = {
                    //pattern("[^-0-9]+([,.][0-9]+)?")
                    if (!_valor.id().equals("")) {
                        id(_valor.id())
                    }

                    classes("form-control")
                    if (_tipoCampo.equals("N"))
                        style { (textAlign("right")); fontSize(fontSmall) }
                    else
                        style { fontSize(fontSmall) }

                    if (!_valor.text().equals("") && _valor.carregado().equals(""))
                        defaultValue(_valor.text())
                    //if (_valor.carregado().equals(""))
                    //    _valor.carregado("sim")
                    //println0("ola carregado = " + _valor.carregado())

                    //onInput { _valor.text(it.value.toString()) }
                    //value(_valor.text())
                    onChange {
                        if (!_tipoCampo.equals("N"))
                            _valor.text(
                                ffValidar(
                                    _valor.text(),
                                    _valor.tipo(), _max
                                )
                            )
                    }
                    onBlur { if (_valor.key().equals("Enter")); gsKey = "Enter"; _acao.invoke(true); }
                    onKeyDown {
                        if ("Enter,Backspace,Delete".contains(it.getNormalizedKey())) {
                            _valor.key(it.getNormalizedKey());
                            //_valor.text(_valor.text_get());
                            gsKey = it.getNormalizedKey(); //println0(it.getNormalizedKey())
                        } else if (!_valor.key().equals(""))
                            _valor.key("")
                    }

                    if ((!_valor.text().equals("") && _valor.carregado().equals("nao")) || !_valor.enabled()) {
                        //_valor.text_set()
                        if (!_valor.carregado().equals("nao") && _valor.enabled()) {
                            _valor.carregado("sim")
                        }
                    }

                    if (!_valor.enabled())
                        disabled()
                    if (_valor.setFocus().equals("true")) {
                        println(
                            "zuza779_1 tipoCampo = " + _valor.tipo()
                                .ffSubstring1(1) + " enabled = " + _valor.enabled() + " focus " + _valor.setFocus()
                        )
                    }
                }

            )
            //println0("zuza779_3_vai imprimir o id=${id}")
            if (_esp)
                ffEspHorizontalMM(3)
        }
    }
}

@Composable
fun ffCombo1Simples(
    _span: String,
    _values: String,
    _opcao: MutableState<String>,
    _width: Int,
    _classes: String,
    _esp: Boolean,
    _onFocusOut: (Boolean) -> Unit,
    _id: String = ""
): Unit {

    var classe = ""
    if (!_classes.equals(""))
        classe = "'$_classes'".replace("'", "\"")
    //println0(classe)
    //Div({ classes(classe); style { width(_width.percent) } }) {

    return Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { Text(_span) }
        Br()
        Div({ classes("form-group", "input-group-append") }) {
            //Div({classes("dlg-40")}) {

            Select(attrs = {
                id(geraId("", _id, "se"))
                classes("custom-select", "mr-sm-2", "dlg-100")
                onInput { _opcao.value = it.value!! }
                onChange {
                    _opcao.value = it.value!!
                }
                onFocusOut { _ -> _onFocusOut.invoke(true) }
            }
            ) {
                var bFirst = true
                var bTraco = false
                for (o in _values.split("#")) {

                    var s = o
                    if (o.contains("-"))
                        s = o.ffPegaCampoAte("-")
                    //if (_seOpcao.value.equals(""))
                    Option(value = s) { Text("$o") }
                    //else if (_seOpcao.value.equals(o))
                    //    Option(value = s, ( "selected")) { Text("$o") }

                    if (bFirst) {
                        _opcao.value = s
                        bFirst = false
                    }
                }
            }
            if (_esp)
                ffEspHorizontalMM(3)
        }
    }

}

@NonRestartableComposable
fun MutableState<String>.getSelectPos(_texto: String): Int {

    //val el = this.getHTMLSelectElement()!!.querySelector("#select")

    val lista = this.textItens().split("#")
    var iCont = 0

    for (s in lista) {

        //println0("@investigar7 $_texto ${lista} ${s.ffCopy(s.indexOf("/"))}")

        if (s == _texto || s.ffCopy(s.indexOf("/")) == _texto) {
            break
        } else {
            iCont++
        }

    }
    //println0("@investigar7 $iCont")
    return iCont
}


/*
@Composable
fun ffNumber1Input99(
    _text: String,
    _valor: MutableState<String>,
    _tipoCampo: String,
    _max: Int,
    _width: Int,
    _esp: Boolean = true,
    _acao: (Boolean) -> Unit

): Unit {

    var width = _width
    if (width == 0)
        width = 100

    if (_valor.tipo().equals(""))
        _valor.tipo(_tipoCampo)

    //   var sKey = ""
    Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { Text("$_text".trim()) }
        Br()
        Div({ classes("form-group", "input-group-append"); style { fontSize(fontSmall) } }) {

            Input(type = InputType.Number,
                attrs = {
                    //if (!_valor.value.equals("-"))
                    //value(_valor.value.toString())
                    //step(9)
                    //min("-9999")
                    //pattern("[^-0-9]+([,.][0-9]+)?")
                    //if (!_valor.text().equals("-"))
                    //if (_valor.first())
                    //    value(_valor.text())

                    classes("form-control")
                    //style { (textAlign("right")); fontSize(fontSmall) }
                    if (_tipoCampo.equals("N"))
                        style { (textAlign("right")); fontSize(fontSmall) }
                    else
                        style { fontSize(fontSmall) }

                    onInput { _valor.text1(it.value) }
                    onChange { _valor.text1(ffValidar(_valor.value, _tipoCampo, _max)) }
                    //onBeforeInput { ff.println0(_valor.value) }
                    //onFocusOut { _valor.value = ffValidar(_valor.value, _tipoCampo, _max) }
                    //onInput { _valor.value = ffValidar(_valor.value, _tipoCampo, _max) }
                    onBlur { if (_valor.key().equals("Enter")) _acao.invoke(true); }
                    onKeyDown {
                        if (it.getNormalizedKey().equals("Enter")) {
                            _valor.key("Enter"); }
                    }

                    //onKeyDown { sKey = it.getNormalizedKey() }
                    if (!_valor.enabled())
                        disabled()
                    if (_valor.setFocus()) {
                        println(
                            "zuza779_1 tipoCampo = " + _valor.tipo()
                                .ffSubstring(1) + " enabled = " + _valor.enabled() + " focus " + _valor.setFocus()
                        )
                    }

                }
            )
            if (_esp)
                ffEspHorizontal(10);
        }
    }
}

 */

fun MutableState<String>.limparTabela() {

    if (this.id().equals(""))
        ffMsgAviso("Impossível limpar tabela, objeto sem nome.")
    else {
        val tbLista1: HTMLTableElement? = document.getElementById(this.id()) as HTMLTableElement?
        if (tbLista1 != null) {
            //tbLista1!!.clear()
            for (i in tbLista1!!.rows.length downTo 2 step 1) {
                tbLista1.deleteRow(i - 1)
            }
            //tbLista1.clear()
            tbLista1.remove()
        }
    }
}

fun MutableState<String>.deleteItem(i: Int) {

    if (this.id().equals(""))
        ffMsgAviso("Impossível limpar tabela, objeto sem nome.")
    else {
        val tbLista1: HTMLTableElement? = document.getElementById(this.id()) as HTMLTableElement?
        tbLista1!!.deleteRow(i)
    }
}

fun MutableState<String>.text_set() {

    //println0("00 - vai setar o HTMLInputElement ${this.id()}")
    if (document.getElementById(this.id()) != null) {
        //println0("1 - vai setar o HTMLInputElement como vazio ou = ${this.text()}")
        var textH: HTMLInputElement? = null
        try {
            textH = document.getElementById(this.id()) as HTMLInputElement?
        } catch (e: Exception) {
            println0(e.message)
        }

        if (textH != null) {
            if (!this.id().equals("") && this.text().equals("")) {
                //println0("2 - vai setar o HTMLInputElement como vazio ou = ${this.text()}")
                textH!!.value = ""
            }
            if (!this.id().equals("") && !this.text().equals("")) {
                try {
                    if (this.tipo().equals("NS") && !this.text().ffSoNumero().equals(this.text())) {
                        //println0("vai mudar o tipo do campo")
                        textH!!.type = "text"
                    }
                    textH!!.value = this.text()
                } catch (e: Exception) {
                    println0(e.message)
                }

            } else if (!this.id().equals("")) {
                //if (!gsDesenvolvedor.equals("P"))
                //  msgAviso("1 - tentou getValue mas o componente está sem identificação ${this.id()} text=${this.text()}")
            }
        }
    }
}


/*
@NonRestartableComposable
fun MutableState<String>.text(_new: String? = "null", _atualizar: Boolean = false): String {


    var sResult = ""

    var sNew: String = "$_new"
    if (sNew.equals("NaN")) {
        println0("pegou NaN ${this.key()}.")
        if (!this.key().equals("") && "Backspace,Delete".contains(this.key())) {
            println0("pegou NaN  entrou ${this.key()}.")
            //this.key("")
            sNew = ""
        } else if (this.value.ffPegaCampo("|text=").ffCopy(1, 1).equals("-"))
            sNew = this.value.ffPegaCampo("|text=").replace("-", "")
        else
            sNew = "-" + this.value.ffPegaCampo("|text=")
    }

    //println0("$sNew   ${this.value.ffPegaCampo("|text=")}")
    if (!sNew.equals("null") && !this.value.ffPegaCampo("|text=").equals(sNew)) {
        //println0("vai fazer o textSet")
        this.value = this.value.ffPegaCampoAlt("|text=", "$sNew")
        this.text_set()
        this.carregado("nao")
        //this.setFocus("")
        //this.value = this.value.ffPegaCampoAlt("|focus=", "")
        println0("$sNew   ${this.value.ffPegaCampo("|text=")}")
    }
    sResult = this.value.ffPegaCampo("|text=")
    if (_atualizar)
        this.atualizar()
    //if (sResult.equals("-"))
    //  sResult = ""

    //println0(sResult)

    return sResult
}

 */

@NonRestartableComposable
fun MutableState<String>.textSimples(_new: String? = "null") {

    this.value = this.value.ffPegaCampoAlt("|text=", _new!!)
    /*
    val ed = this.getHTMLInputElement()
    if (ed != null)
        ed.setSelectionRange(ed.value.length, ed.value.length)
    //ed.setSelectionRange(ed.selectionStart, ed.selectionEnd, ed.selectionDirection)


     */
    //this.getHTMLInputElement()!!.selectionEnd
}


@NonRestartableComposable
fun MutableState<String>.text(_new: String? = "null", _onInput: Boolean = false, _atualizar: Boolean = false): String {

    var sResult = ""

    val bMobile = gsBrowser.contains("mobile")
    var sNew: String = "$_new"
    val sTeste = this.value.ffPegaCampo("|text=")

    //msgAviso("gsKey = ${gsKey}, texto = $sTeste, new = $sNew, mobile = $bMobile, keyCount = ${keyCount}, onInput = $_onInput")
    if (this.tipo().equals("N") && (sNew.equals("NaN") || gsKey.equals("-"))) {

        if (gsKey.equals("Unidentified")
            && bMobile
            //&& sNew.equals("NaN")
            && _onInput
            && this.value.ffPegaCampo("|text=").length == 2
            && this.value.ffPegaCampo("|text=").ffCopy(1, 1).equals("-")
        ) {
            //msgAviso("gsKey99 = ${gsKey}, texto = $sTeste, new = $sNew, mobile = $bMobile, keyCount = ${keyCount}")
            keyCount += 1
            if (gsTextAnt.equals(sTeste))
                keyCount = 5
        }


        if (keyCount >= 2) {
            sNew = ""
            gsKey = ""
            keyCount = 0

        } else {
            println0("pegou NaN ${gsKey}..")
            if (!gsKey.equals("") && "Backspace,Delete".contains(gsKey)) {
                println0("pegou NaN entrou ${gsKey}.")
                //sNew = ""
            } else if (bMobile && this.value.ffPegaCampo("|text=").ffCopy(1, 1).equals("-")) {
                sNew = this.value.ffPegaCampo("|text=").replace("-", "")
            } else { //if (this.value.ffPegaCampo("|text=").equals("NaN")) {
                sNew = "-" + this.value.ffPegaCampo("|text=")
                gsTextAnt = sNew
                gsKey = ""
            }
        }
    }

    if (bMobile
        && this.value.ffPegaCampo("|text=").ffCopy(1, 1).equals("-")
        && this.value.ffPegaCampo("|text=").length == 2
        && !gsTextAnt.equals(sNew) && _onInput
    ) {
        sNew = ""
        gsKey = ""
        //this.getHTMLImputElement()!!.selectionEnd
    }

    //println0("$sNew   ${this.value.ffPegaCampo("|text=")}")
    //println0("text() $_new $_onInput $_atualizar $sTeste")
    if ((!sNew.equals("null") || sNew.equals("")) && !this.value.ffPegaCampo("|text=").equals(sNew)) {
        //println0("vai fazer o textSet ${this.id()} $sNew")
        //println0("texto a ser aplicado $sNew.")

        this.value = this.value.ffPegaCampoAlt("|text=", "$sNew")
//        println0(this.value)
        this.text_set()
        this.carregado("nao")
        //this.setFocus("")
        //this.value = this.value.ffPegaCampoAlt("|focus=", "")
        //println0("$sNew   ${this.value.ffPegaCampo("|text=")}")
        //println0("${this.value.ffPegaCampo("id")} resultado da aplicacao = ${this.value.ffPegaCampo("|text=")}")
    }
    sResult = this.value.ffPegaCampo("|text=")

    if (_atualizar)
        this.atualizar()

    if (gsKey.equals("Unidentified")
        && bMobile
        //&& sNew.equals("NaN")
        && _onInput
        && this.value.ffPegaCampo("|text=").length == 2
        && this.value.ffPegaCampo("|text=").ffCopy(1, 1).equals("-")
        && gsTextAnt.equals(sNew)
        && this.tipo().equals("N")
    ) {
        this.getHTMLInputElement()!!.selectionEnd
    }


    //if (sResult.equals("-"))
    //  sResult = ""

    //println0(sResult)

    return sResult
}

@NonRestartableComposable
fun MutableState<String>.textAnt(_new: String? = "null", _atualizar: Boolean = false): String {

    var sResult = ""

    var sNew: String = "$_new"
    if (sNew.equals("NaN")) {
        println0("pegou NaN ${this.key()}.")
        if (!this.key().equals("") && "Backspace,Delete".contains(this.key())) {
            println0("pegou NaN  entrou ${this.key()}.")
            //this.key("")
            sNew = ""
        } else if (this.value.ffPegaCampo("|textAnt=").ffCopy(1, 1).equals("-"))
            sNew = this.value.ffPegaCampo("|textAnt=").replace("-", "")
        else
            sNew = "-" + this.value.ffPegaCampo("|textAnt=")
    }

    //println0("$sNew   ${this.value.ffPegaCampo("|textAnt=")}")
    if (!sNew.equals("null") && !this.value.ffPegaCampo("|textAnt=").equals(sNew)) {
        this.value = this.value.ffPegaCampoAlt("|textAnt=", "$sNew")
        //this.value = this.value.ffPegaCampoAlt("|focus=", "")
        println0("$sNew   ${this.value.ffPegaCampo("|textAnt=")}")
    }
    sResult = this.value.ffPegaCampo("|textAnt=")
    if (_atualizar)
        this.atualizar()
    //if (sResult.equals("-"))
    //  sResult = ""

    //println0(sResult)

    return sResult
}

@NonRestartableComposable
fun MutableState<String>.carregado(_new: String? = "null"): String { //indicar sim ou nao

    var sResult = ""

    if (_new != null && !_new.equals("null")) {
        this.value = this.value.ffPegaCampoAlt("|carregado=", _new)
    }
    sResult = this.value.ffPegaCampo("|carregado=")

    return sResult
}

@NonRestartableComposable
fun MutableState<String>.json(_new: String? = "null"): String {

    var sResult = ""

    if (_new != null && !_new.equals("null")) {
        this.value = this.value.ffPegaCampoAlt("|json=", _new.replace("|", "##"))
    }
    sResult = this.value.ffPegaCampo("|json=").replace("##", "|")

    return sResult
}

/*
fun MutableState<String>.jsonLer(_new: String? = "null"): String {

    var sResult = ""

    if (_new != null && !_new.equals("null"))
        this.value = this.value.ffPegaCampoAlt("|json=", _new.replace("|", "##"))
    sResult = this.value.ffPegaCampo("|json=").replace("##","|")

    return sResult
}

 */
fun MutableState<String>.jsonL(_new: String? = "null"): String {

    var sResult = ""

    sResult = this.value.ffPegaCampo("|json=").replace("##", "|")
    this.value = this.value.ffPegaCampoAlt("|json=", "")

    return sResult
}

@NonRestartableComposable
fun MutableState<String>.clickTipo(_new: String? = "null"): String {

    var sResult = ""

    if (_new != null && !_new.equals("null")) {
        this.value = this.value.ffPegaCampoAlt("|clickTipo=", _new)
    }
    sResult = this.value.ffPegaCampo("|clickTipo=")

    return sResult
}

@NonRestartableComposable
fun MutableState<String>.clickLimpar() {
    //this.value.ffPegaCampoAlt("|clickTipo=", "")
    //this.value.ffPegaCampoAlt("|clickObj=", "-1")
    giClick = -1
    this.clickTipo("")
    this.clickObj("-1")
}

@NonRestartableComposable
fun MutableState<String>.clickObj(_new: String? = "null"): Int {

    if (_new != null && !_new.equals("null")) {
        this.value = this.value.ffPegaCampoAlt("|clickObj=", _new)
        giClick = _new.ffVsi()
    }

    var iResult = -1
    if (giClick == this.value.ffPegaCampo("|clickObj=").ffVsi())
        iResult = giClick

    //if (iResult != -1)
    //    this.atualizar()

    println0("zuza123 iResult = $iResult giClick = $giClick clickObj = ${this.value.ffPegaCampo("|clickObj=")}")

    return iResult
}

@NonRestartableComposable
fun MutableState<String>.clickObjLimpar() {

    giClick = -1

}

@NonRestartableComposable
fun MutableState<String>.textItens(_new: String? = "null"): String {

    var sResult = ""

    //separador para o select é #
    if (_new != null && !_new.equals("null"))
        if (this.value.ffPegaCampo("|textItens=").trim().equals("") || _new.equals("")) {
            this.value = this.value.ffPegaCampoAlt("|textItens=", _new.replace("|", ".."))
            if (_new.equals(""))
                this.textSelect("")
            if (_new.contains("#"))
                this.count(_new.ffCarac("#"))
        }
    sResult = this.value.ffPegaCampo("|textItens=")
    //println0("textItens somando " + _new)
    //println0("textItens ${this.value}")

    return sResult
}

@NonRestartableComposable
fun MutableState<String>.count(_new: Int? = null): Int {

    //return this.value
    var sResult = ""
    if (_new != null && !_new.equals("null"))
        if (!this.value.ffPegaCampo("|count=").equals(_new))
            this.value = this.value.ffPegaCampoAlt("|count=", _new.toString())
    sResult = this.value.ffPegaCampo("|count=")
    return sResult.ffVsi()

}

fun MutableState<String>.tipo(_new: String? = "null"): String {
    var sResult = ""

    if (_new != null && !_new.equals("null"))
        this.value = this.value.ffPegaCampoAlt("|tipo=", _new)
    sResult = this.value.ffPegaCampo("|tipo=")

    return sResult
}

fun MutableState<String>.id(_id: String? = "null"): String {
    var sResult = ""

    if (_id != null && !_id.equals("null"))
        if (this.value.ffPegaCampo("|id=").trim().equals(""))
            this.value = this.value.ffPegaCampoAlt("|id=", _id)
    sResult = this.value.ffPegaCampo("|id=")

    return sResult
}

//@NonRestartableComposable
//fun MutableState<String>.onFocus(_acao: (Boolean) -> Unit) {
//
//    println0("zuza99 onKeyPressENTER ${this.key()} e gsKey=${gsKey}")
//    if (this.key().equals("Enter") && gsKey.equals("Enter")) {
//        gsKey = ""
//        _acao.invoke(true)
//    }
//}

fun MutableState<String>.onFocus(_acao: (Boolean) -> Unit) {
    if (this.focused())
        _acao.invoke(true)
}

@NonRestartableComposable
fun MutableState<String>.onKeyPressENTER(_acao: (Boolean) -> Unit) {

    //println0("zuza99 onKeyPressENTER ${this.key()} e gsKey=${gsKey}")
    if (this.key().equals("Enter") && gsKey.equals("Enter")) {
        gsKey = "false"
        this.key("v")
        _acao.invoke(true)
        //ffMsgWindow("verificou evendo onKeyPressENTER")
    }

}

/*
fun MutableState<String>.onKeyPressENTER(): Boolean {

    var bReturn = false
    if (this.key().equals("Enter") && gsKey.equals("Enter")) {
        gsKey = "false"
        this.key("v")
        bReturn = true
    } else
        bReturn = false

    println0("zuza998 onKeyPressENTER ${this.key()} e gsKey=${gsKey} $bReturn")
    return bReturn
}

 */

fun MutableState<String>.keySet(_key: String? = "null") {

    if (_key != null && !_key.equals("null")) {
        this.value = this.value.ffPegaCampoAlt("|key=", _key)
        gsKey = _key
    }
}

@NonRestartableComposable
fun MutableState<String>.key(_key: String? = "null"): String {

    var sResult = ""

    if (_key != null && !_key.equals("null")) {
        this.value = this.value.ffPegaCampoAlt("|key=", _key)
        //gsKey = _key
        //println0("key=" + this.value.ffPegaCampo("|key=") + " gsKey=" + gsKey)
    }

    sResult = this.value.ffPegaCampo("|key=")
    return sResult

    //if (!_key.equals("null")) {
    //  gsKey = _key!!
//        if (_key!!.equals("Enter")) {
//            println0("enviou atualizar $gsKey")
//            this.atualizar()
//        }
    //}
    //println0("99 key = $gsKey")

    //return gsKey
}

//fun MutableState<String>.keyL(): String {
//    var sResult = ""
//
//    sResult = this.value.ffPegaCampo("|key=")
//    this.value = this.value.ffPegaCampoAlt("|key=", "")
//
//    return sResult
//}

fun MutableState<String>.atualizar() {

    //println0("atualizar ")
//    this.carregado("nao")
    val sTeste = this.value.ffPegaCampo("|atualizar=")
    if (sTeste.equals("true"))
        this.value = this.value.ffPegaCampoAlt("|atualizar=", "false")
    else
        this.value = this.value.ffPegaCampoAlt("|atualizar=", "true")
    //println0(this.value + " key=" + gsKey)
}

fun MutableState<String>.enabled_ant(_enabled: Boolean? = null): Boolean {

    var sResult = true
    //println0("zuza87 " + _enabled.toString())
    //if (_enabled != null && this.value.ffPegaCampo("|enabled=").toBoolean() != _enabled)
    if (_enabled != null && this.value.ffPegaCampo("|enabled=").toBoolean() != _enabled)
        this.value = this.value.ffPegaCampoAlt("|enabled=", _enabled.toString())

    if (this.value.ffPegaCampo("|enabled=").equals("false")) {
        val text: HTMLInputElement? = this.getHTMLInputElement()
        if (text != null)
            text.disabled = true

        sResult = false
    }

    return sResult
}

fun MutableState<String>.enabled(_enabled: Boolean? = null): Boolean {

    var sResult = true
    //println0("zuza87 " + _enabled.toString())
    //if (_enabled != null && this.value.ffPegaCampo("|enabled=").toBoolean() != _enabled)
    if (_enabled != null) {
        if (this.value.ffPegaCampo("|enabled=").toBoolean() != _enabled) {
            this.value = this.value.ffPegaCampoAlt("|enabled=", _enabled.toString())
        }
        sResult = _enabled
    }

    if (_enabled == null) {
        sResult = this.value.ffPegaCampo("|enabled=").toBoolean()
    }

    return sResult
}

/*
fun MutableState<String>.enabledANTBom(_enabled: Boolean? = null): Boolean {

    var sResult = true
    //println0("zuza87 " + _enabled.toString())
    //if (_enabled != null && this.value.ffPegaCampo("|enabled=").toBoolean() != _enabled)
    if (_enabled != null) {
        if (this.value.ffPegaCampo("|enabled=").toBoolean() != _enabled) {
            this.value = this.value.ffPegaCampoAlt("|enabled=", _enabled.toString())
        }

        //altera o componente na tela
        /*
        var _comp: HTMLHtmlElement = null
        if (this.id().ffCopy(3).contains("bt"))
            _comp = this.getHTMLElementGeneric()

         */

        val comp: HTMLInputElement? = this.getHTMLInputElement()
        if (comp != null) {
            comp.disabled = !_enabled
            //println0("@investigar ${comp.disabled}")
            sResult = _enabled
        }
    }

    if (_enabled == null) {
        val text: HTMLInputElement? = this.getHTMLInputElement()
        if (text != null && text.disabled)
            sResult = false
    }

    return sResult
}

 */

fun MutableState<String>.enabled_bad(_enabled: Boolean? = null): Boolean {

    var bResult = false
    //println0("zuza87 " + _enabled.toString())
    //if (_enabled != null && this.value.ffPegaCampo("|enabled=").toBoolean() != _enabled)
    if (_enabled != null && this.value.ffPegaCampo("|enabled=").toBoolean() != _enabled)
        this.value = this.value.ffPegaCampoAlt("|enabled=", _enabled.toString())

    if (this.value.ffPegaCampo("|enabled=").equals("false")) {
        val text: HTMLInputElement? = this.getHTMLInputElement()
        if (text != null) {
            if (!text.disabled) {
                text.disabled = true
                bResult = false
            } else {
                text.disabled = false
                bResult = true
            }
        }
    }

    return bResult
}

fun MutableState<String>.status(_status: String? = null): String {

    //println0("zuza87 " + _enabled.toString())
    if (_status != null)
        this.value = this.value.ffPegaCampoAlt("|status=", _status)
    return this.value.ffPegaCampo("|status=")
}

//fun MutableState<String>.setFocus(_focus: Boolean? = null): Boolean {
//
//    if (_focus != null)
//        this.value = this.value.ffPegaCampoAlt("|focus=", _focus.toString())
//    return this.value.ffPegaCampo("|focus=").toBoolean()
//}
//@Composable
fun MutableState<String>.setFocus(_focus: String? = null, _force: Boolean = false): String {

//    if (this.enabled()) {
        println0("@setFocus id=${this.id()}")
        if (_focus != null) {
            this.value = this.value.ffPegaCampoAlt("|focus=", _focus)
            if (_force)
                (document.getElementById(this.id()) as HTMLInputElement).focus()
        }
//    }
    return this.value.ffPegaCampo("|focus=")
}

fun MutableState<String>.setFocusSimples(_force: Boolean = false) {

    //if (this.enabled()) {
        println0("@setFocusSimples id=${this.id()}")
        try {
            if (this.id().equals(""))
                println0("$this")
            if (this.id().ffCopy(3).contains("bt"))
                (document.getElementById(this.id()) as HTMLButtonElement).focus()
            if (!this.id().equals("") && (this.enabled() || _force))
                (document.getElementById(this.id()) as HTMLInputElement).focus()
            this.carregado("n")

        } catch (e: Exception) {
            println0("Falha ao fazer setFocus ${this.id()} erro = ${e.message}")
        }
    //}

    //*** isso também serviria
    /*
                SideEffect {
                    (document.getElementById("${_t}_inProduto") as HTMLInputElement).focus()
                }

     */
}

fun MutableState<String>.select() {
    try {

        if (!this.id().equals(""))
            (document.getElementById(this.id()) as HTMLInputElement).select()
        this.carregado("n")

    } catch (e: Exception) {
        println0("Falha ao fazer setFocus ${this.id()} erro = ${e.message}")
    }
}

fun MutableState<String>.focused(_focus: Boolean? = null): Boolean {

    //if (_focus != null)
    //  this.value = this.value.ffPegaCampoAlt("|focus=", _focus.toString())
    if (this.value.ffPegaCampo("|focus=").equals("entrou"))
        return true
    else
        return false
}

//@Composable
//@NonRestartableComposable
fun MutableState<String>.setVal(_valor: String) {

    //SideEffect {
    val _text: HTMLInputElement? = document.getElementById(this.id()) as HTMLInputElement
    if (_text != null) {
        println0("setVal $_valor. _text = ${_text.value}. this = ${this.text()}.")
        if (!_text.value.equals(_valor)) {
            //println0("setou o _text.value = " + _text.value)
            _text.value = _valor
        }

        if (!this.text().equals(_valor)) {
            //println0("setou o !this.text() = " + _text.value)
            this.text("$_valor")
        } else {
            println0("tentou setValue mas o componente está sem identificação 1")
            if (!gsDesenvolvedor.equals("P") && gsUrlLogon.contains("localhost")) {
                ffMsgAviso("tentou setValue mas o componente está sem identificação 1")

            }
        }
    }
}

fun MutableState<String>.inputRecar() {

//    val htmlDiv1 = document.getElementById("div${this.id()}") as HTMLDivElement
//    htmlDiv1.clear()

    val input5 = document.getElementById(this.id()) as HTMLInputElement
    input5.clear()
    input5.enabled(true)

}

fun MutableState<String>.inputType(_tipoCampo: String) {

    if (!this.id().equals("")) {
        val inp = document.getElementById(this.id()) as HTMLInputElement
        if (_tipoCampo.ffSubstring1(1).equals("D") && this.enabled() && this.text().length < 14) {
            inp.type = "text"
        } else if (_tipoCampo.ffSubstring1(1).equals("N") && this.enabled() && this.text().length < 14) {
            inp.type = "number"
        } else if (_tipoCampo.equals("NS") && this.enabled()) {
            inp.type = "text"
        } else if (_tipoCampo.equals("PS") && this.enabled()) {
            inp.type = "password"
        } else {
            inp.type = "text"
        }
    }
}

fun MutableState<String>.clear() {

    this.text("")
    this.textAnt("")
    if (this.getHTMLInputElement() != null) {
        //println0("o texto do input é ${this.getHTMLInputElement()!!.textContent}")
        //println0("o texto do text input é ${this.text()}")
        //println0(this.value)
        this.getHTMLInputElement()!!.clear()
        this.getHTMLInputElement()!!.value = ""
        this.getHTMLInputElement()!!.textContent = ""
        this.getHTMLInputElement()!!.innerText = ""
    }
}

fun MutableState<String>.span(_span: String? = null): String {

    //println0("zuza87 " + _enabled.toString())
    if (_span != null && !_span.equals("")) {
        this.value = this.value.ffPegaCampoAlt("|span=", _span)
        if (!this.id().equals("") && document.getElementById("span${this.id()}") != null) {
            (document.getElementById("span${this.id()}") as HTMLSpanElement)!!.textContent = this.span()
        }
    }
    return this.value.ffPegaCampo("|span=")
}

fun MutableState<String>.getHTMLInputElement(): HTMLInputElement? {

//    val htmlDiv1 = document.getElementById("div${this.id()}") as HTMLDivElement
//    htmlDiv1.clear()
    //println0(this.id())
    if (!this.id().equals("") && document.getElementById(this.id()) != null) {
        return document.getElementById(this.id()) as HTMLInputElement
    } else {
        return null
    }

}

fun MutableState<String>.getHTMLSelectElement(): HTMLSelectElement? {

    if (!this.id().equals("") && document.getElementById(this.id()) != null) {
        val teste = document.getElementById(this.id()) as HTMLSelectElement
        if (this.textSelect() != teste.value) {
            this.textSelect(teste.value)
        }
        //println0("getHTMLSelectElement encontrado ${teste!!.id}")
        return teste
    } else {
        return null
    }

}

fun MutableState<String>.getHTMLElementGeneric(): Element? {

    if (!this.id().equals("") && document.getElementById(this.id()) != null) {
        val teste = document.getElementById(this.id())
        println0("getHTMLSelectElement encontrado ${teste!!.id}")
        return teste
    } else {
        return null
    }
}

fun HTMLSelectElement.dRemove(_index: Int) {

    var sTeste = ""
    //println0("vai imprimir o comando JS11")
    try {
//        ffJSAguarda("${this.remove(0)}") {}
        //ffJavaScript("${this.remove(0)};")

        sTeste = "${this.remove(0)};"

        println0("vai imprimir o comando JS")
        println0(sTeste)
        //eval(sTeste)
        //ffJSAguarda(sTeste) {}

    } catch (e: Exception) {

    } finally {

    }
}

fun MutableState<String>.tela(_tela: String? = null): String {

    if (_tela != null)
        this.value = this.value.ffPegaCampoAlt("|tela=", _tela)
    return this.value.ffPegaCampo("|tela=")
}

@NonRestartableComposable
fun MutableState<String>.text_getPROBLEMA(): String {

    var sText = ""
    if (!this.id().equals("")) {
        try {
            sText = (document.getElementById(this.id()) as HTMLInputElement).value
            if (!this.text().equals(sText))
                this.text(sText)
        } catch (e: Exception) {
            println0(e.message)
        }

    } else {
        ffMsgAviso("2 - tentou getValue mas o componente está sem identificação")
    }

    /*
        var sText = ""
        if (!this.id().equals("")) {
            val ed = this.getHTMLInputElement()
            if (ed != null) {
                sText = ed.value.toString()
                //if (!this.text().equals(sText))
                  //  this.text(sText)
            }
    //            _valor.textSimples(ed.value.toString())
        }

     */
    return sText
}

@NonRestartableComposable
fun MutableState<String>.inputExiste(): Boolean {

    var bResult = false

    val text: HTMLInputElement? = this.getHTMLInputElement()
    if (text != null)
        bResult = true

    return bResult
}

